import type React from 'react';

import { Card, Image, Link, Text } from '@change/ds-core-ui';

import { Translate, TypedTranslate } from '@change-corgi/core-react/i18n';

import type { InfoCardLinkType } from '#src/app/pages/about/main/shared/types';

export const InfoCardLink: React.FC<InfoCardLinkType> = ({ to, icon, title, description }) => {
	return (
		<Card className="flex flex-col items-center justify-center p-4">
			<Image src={icon} alt="" className="h-16 w-16" />
			<Text as="h4" size="x-small" variant="heading" className="mt-4 text-center">
				<TypedTranslate value={title} />
			</Text>
			<Text as="p" className="mt-2 mb-4 text-center">
				<TypedTranslate value={description} />
			</Text>
			<Link href={to} data-qa="learn-more-link">
				<Translate value="fe.pages.about.learn_more_btn" />
			</Link>
		</Card>
	);
};
